import { useSelector } from 'react-redux';
import { Button, DialogActions, DialogContent } from '@mui/material';
import useAuth from 'auth/useAuth';
import type { RootState } from 'store';
import { AgreementAccordion } from './AgreementAccordion';
import Dialog from 'components/Dialog';

interface AgreementDialogProps {
  open: boolean;
  onClose?: () => void;
  onApproval?: () => void;
}

const AgreementDialog = ({
  open,
  onClose,
  onApproval,
}: AgreementDialogProps) => {
  const { logout } = useAuth();
  const { isApproved, agreements } = useSelector(
    (state: RootState) => state.agreement,
  );

  return (
    <Dialog title='Agreements PlantDesigner' open={open} onClose={onClose}>
      <DialogContent>
        {agreements?.map((a) => (
          <AgreementAccordion agreement={a} key={a.id} />
        ))}
      </DialogContent>
      <DialogActions>
        {isApproved ? (
          <Button onClick={onClose} color='primary' variant='outlined'>
            Close
          </Button>
        ) : (
          <>
            <Button onClick={logout} color='primary' variant='outlined'>
              Logout
            </Button>
            <Button onClick={onApproval} color='primary' variant='contained'>
              Accept
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AgreementDialog;
